import { filterOnlyPitches } from './byResultTypes.js';
import {
    filterOnlyMatchingTagId, filterOnlyMatchingPitchResult, filterOnlyMatchingPitchType,
    filterOnlyMatchingBatterTagId, filterOnlyMatchingBatterHandedness, filterOnlyMatchingPitcherHandedness,
	filterOnlyMatchingNumberOfOuts, filterOnlyMatchingNumberOfBalls, filterOnlyMatchingNumberOfStrikes, filterOnlyMatchingRunnersOn, filterOnlyMatchingPitchSet, filterOnlyMatchingStrikeZoneSectors,
} from './byParameterValue.js';
import { filterWithDateBetween } from './byResultDate.js';

const buildFiltersForPitchingSummary = function({
    // tagging context
    pitcherIds, pitcherHandedness, pitchResults, pitchTypes, pitchSet, batterIds, batterHandedness, zones,
    // scoring context
    outs, balls, strikes, runnersOn,
    // session context
    //sessionIds,
    // date range filtering
    dateFrom, dateTo,// season,
}){
    let pitchingSummaryFilters = filterOnlyPitches();

    const taggingFilters = buildTaggingFiltersForPitchingSummary({ pitcherIds, pitcherHandedness, pitchResults, pitchTypes, pitchSet, batterIds, batterHandedness, zones });
    if (taggingFilters instanceof Array){
        pitchingSummaryFilters = pitchingSummaryFilters.concat(taggingFilters);
    }

    const scoringFilters = buildScoringFiltersForPitchingSummary({ outs, balls, strikes, runnersOn });
    if (scoringFilters instanceof Array){
        pitchingSummaryFilters = pitchingSummaryFilters.concat(scoringFilters);
    }

    const dateFilters = filterWithDateBetween(dateFrom, dateTo);
    if (dateFilters instanceof Array){
        // TODO - check if it's Date type
        pitchingSummaryFilters = pitchingSummaryFilters.concat(dateFilters);
    }

    return pitchingSummaryFilters;
};

const buildTaggingFiltersForPitchingSummary = function({
    pitcherIds, pitcherHandedness, pitchResults, pitchTypes, pitchSet, batterIds, batterHandedness, zones
}){
    pitchResults = pitchResults || [];
    pitchTypes = pitchTypes || [];
    pitchSet = pitchSet || '';
    batterIds = batterIds || [];
    pitcherIds = pitcherIds || [];
    batterHandedness = batterHandedness || '';
    pitcherHandedness = pitcherHandedness || '';
    zones = zones || [];

    let taggingFilters = [];

    if (pitcherIds && pitcherIds.length){
        taggingFilters = taggingFilters.concat(filterOnlyMatchingTagId(pitcherIds));
    }
    if (pitcherHandedness){
        taggingFilters = taggingFilters.concat(filterOnlyMatchingPitcherHandedness(pitcherHandedness));
    }
    if (pitchResults && pitchResults.length){
        taggingFilters = taggingFilters.concat(filterOnlyMatchingPitchResult(pitchResults));
    }
    if (pitchTypes && pitchTypes.length){
        taggingFilters = taggingFilters.concat(filterOnlyMatchingPitchType(pitchTypes));
    }
    if (pitchSet){
        taggingFilters = taggingFilters.concat(filterOnlyMatchingPitchSet(pitchSet));
    }
    if (batterIds && batterIds.length){
        taggingFilters = taggingFilters.concat(filterOnlyMatchingBatterTagId(batterIds));
    }
    if (batterHandedness){
        taggingFilters = taggingFilters.concat(filterOnlyMatchingBatterHandedness(batterHandedness));
    }
    if (zones && zones.length){
        taggingFilters = taggingFilters.concat(filterOnlyMatchingStrikeZoneSectors(zones));
    }

    return taggingFilters;
};

const buildScoringFiltersForPitchingSummary = function({
    outs, balls, strikes, runnersOn,
}){
    outs = outs || [];
    balls = balls || [];
    strikes = strikes || [];
    runnersOn = runnersOn || [];

    let scoringFilters = [];

    if (outs && outs.length){
        scoringFilters = scoringFilters.concat(filterOnlyMatchingNumberOfOuts(outs));
    }

    if (balls && balls.length){
        scoringFilters = scoringFilters.concat(filterOnlyMatchingNumberOfBalls(balls));
    }

    if (strikes && strikes.length){
        scoringFilters = scoringFilters.concat(filterOnlyMatchingNumberOfStrikes(strikes));
    }

    if (runnersOn && runnersOn.length){
        scoringFilters = scoringFilters.concat(filterOnlyMatchingRunnersOn(runnersOn));
    }

    return scoringFilters;
};

export default buildFiltersForPitchingSummary;